
<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">贝利婴幼儿发展量表第四版中文·标准版统计分析系统</div>
      <div class="activation-box" @click="goActivation" style="cursor: pointer">
        <img src="/images/activation-icon.png" alt=""  style="cursor: pointer">
        <span  style="cursor: pointer">新主试激活</span>
      </div>
    </div>
    <div class="main-body">
      <div class="login-container">
        <div class="login-box">
          <div class="name">用户登录</div>
          <div class="small-name">贝利婴幼儿发展量表第四版中文·标准版统计分析系统</div>
          <a-form-model ref="form" :model="formModel"  :rules="formRules" class="login-form" autoComplete="off">
            <a-form-model-item label="" prop="account">
              <a-input  placeholder="账号" class="cu-input cu-input-w" v-model="formModel.account" allowClear />
            </a-form-model-item>
            <a-form-model-item label="" prop="pwd">
              <a-input type="password" placeholder="密码" class="cu-input cu-input-w" v-model="formModel.pwd" allowClear />
            </a-form-model-item>
            <a-form-model-item label="">
              <button class="captcha-trigger" type="button" @click="openClickCaptcha">
                <span class="captcha-trigger-icon">
                  <a-icon :type="captchaVerified ? 'check-circle' : 'safety-certificate'" />
                </span>
                <span class="captcha-trigger-text">
                  <strong>{{ captchaVerified ? '安全验证已完成' : '点击完成安全验证' }}</strong>
                  <em>{{ captchaVerified ? '登录失败后需重新验证' : '弹出汉字点选验证' }}</em>
                </span>
                <a-icon class="captcha-trigger-arrow" type="right" />
              </button>
            </a-form-model-item>
          </a-form-model>
          <div class="btn" @click="login">登录</div>
          <div class="more">
            <span @click="goForgetPassword">忘记密码?</span>
            <i></i>
            <span @click="goActivation">新主试激活</span>
          </div>
        </div>
        <div style="display: flex;margin-top: 10px;padding: 0 10px">
<!--          <div style="flex: 1;display: flex;justify-content: flex-start"><img style="width: 160px" src="/images/login-bottom-1.png" alt=""></div>-->
<!--          <div style="flex: 1;display: flex;justify-content: flex-end"><img style="width: 160px" src="/images/login-bottom-2.png" alt=""></div>-->
          <img src="/images/login-bottom.png" style="width: 100%" alt="">
        </div>
      </div>
    </div>
    <a-modal
      title="安全验证"
      :visible="captchaVisible"
      :width="440"
      :maskClosable="false"
      @cancel="closeClickCaptcha"
    >
      <div class="captcha-modal">
        <div class="captcha-target">
          <span>请按图片顺序点击 3 个汉字</span>
          <img v-if="clickCaptcha.promptImageBase64" :src="clickCaptcha.promptImageBase64" alt="验证顺序" draggable="false">
        </div>
        <div ref="captchaImage" class="captcha-image-stage" @click="handleCaptchaImageClick">
          <img v-if="clickCaptcha.imageBase64" :src="clickCaptcha.imageBase64" alt="点选验证码" draggable="false">
          <span
            v-for="(point, index) in selectedPoints"
            :key="index"
            class="captcha-point"
            :style="pointStyle(point)"
          >{{ index + 1 }}</span>
        </div>
        <div class="selected-line">
          <span>点击进度</span>
          <strong>{{ selectedPoints.length }} / {{ clickCaptcha.targetCount }}</strong>
        </div>
      </div>
      <template slot="footer">
        <a-button :disabled="captchaVerifying" @click="refreshClickCaptcha">
          <a-icon type="reload" />换一组
        </a-button>
        <a-button :disabled="captchaVerifying || selectedPoints.length === 0" @click="undoCaptchaPoint">
          <a-icon type="undo" />撤销
        </a-button>
        <a-button type="primary" :loading="captchaVerifying" @click="confirmClickCaptcha">确认</a-button>
      </template>
    </a-modal>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
  import * as Api from './api';
  import {GetInfo} from '../../commonApi';
  import {message} from "ant-design-vue";

  export default {
    data() {
      return {
        formModel: {
          "account":"",
          "pwd":"",
          "code_key":"",
          "verification_code":""
        },
        formRules: {
          account: [
            { required: true, message: '请输入账号', trigger: 'change' },
          ],
          pwd: [
            { required: true, message: '请输入密码', trigger: 'change' },
          ],
        },
        captchaVisible: false,
        captchaVerified: false,
        captchaVerifying: false,
        selectedPoints: [],
        clickCaptcha: {
          codeKey: '',
          imageBase64: '',
          promptImageBase64: '',
          imageWidth: 360,
          imageHeight: 210,
          targetCount: 3
        }
      };
    },
    methods: {
      async login() {
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            if (!this.captchaVerified || !this.formModel.code_key || !this.formModel.verification_code) {
              message.warning({ content: '请先完成安全验证' });
              await this.openClickCaptcha();
              return;
            }
            try {
              const res = await Api.Login(this.formModel);
              if (res && res.code == 0) {
                window.localStorage.setItem('login_code', res.login_code);
                window.localStorage.setItem('login_time', new Date());
                message.success({ content: res.message});
                this.getInfo()
              }
            } catch (e) {
              this.resetCaptchaValue();
            }
          }
        });
      },
      async getInfo() {
        const res = await GetInfo({});
        if (res && res.code == 0) {
          window.localStorage.setItem('abas_user', JSON.stringify(res.chiefExaminer))
          setTimeout(()=> {
            this.$router.push({ path: "/" });
          }, 1500);
        }
      },
      goForgetPassword() {
        this.$router.push({path: '/forget-password'})
      },
      goActivation() {
        this.$router.push({path: '/activation'})
      },
      resetCaptchaValue() {
        this.captchaVerified = false;
        this.formModel.code_key = '';
        this.formModel.verification_code = '';
        this.selectedPoints = [];
      },
      async fetchClickCaptcha() {
        const res = await Api.QueryClickCaptcha();
        this.clickCaptcha = {
          codeKey: res.codeKey,
          imageBase64: res.imageBase64,
          promptImageBase64: res.promptImageBase64,
          imageWidth: res.imageWidth,
          imageHeight: res.imageHeight,
          targetCount: res.targetCount
        };
        this.resetCaptchaValue();
      },
      async openClickCaptcha() {
        try {
          await this.fetchClickCaptcha();
          this.captchaVisible = true;
        } catch (e) {
          this.captchaVisible = false;
        }
      },
      async refreshClickCaptcha() {
        await this.fetchClickCaptcha();
      },
      closeClickCaptcha() {
        this.captchaVisible = false;
        this.selectedPoints = [];
      },
      handleCaptchaImageClick(event) {
        if (this.selectedPoints.length >= this.clickCaptcha.targetCount) {
          message.warning({ content: `最多点击${this.clickCaptcha.targetCount}个汉字` });
          return;
        }
        const rect = this.$refs.captchaImage.getBoundingClientRect();
        this.selectedPoints.push({
          x: Math.round((event.clientX - rect.left) * this.clickCaptcha.imageWidth / rect.width),
          y: Math.round((event.clientY - rect.top) * this.clickCaptcha.imageHeight / rect.height)
        });
      },
      pointStyle(point) {
        return {
          left: `${point.x / this.clickCaptcha.imageWidth * 100}%`,
          top: `${point.y / this.clickCaptcha.imageHeight * 100}%`
        };
      },
      undoCaptchaPoint() {
        this.selectedPoints.pop();
      },
      async confirmClickCaptcha() {
        if (this.selectedPoints.length !== this.clickCaptcha.targetCount) {
          message.warning({ content: `请按提示点击${this.clickCaptcha.targetCount}个汉字` });
          return;
        }
        this.captchaVerifying = true;
        try {
          const res = await Api.VerifyClickCaptcha({
            codeKey: this.clickCaptcha.codeKey,
            points: this.selectedPoints
          });
          this.formModel.code_key = res.codeKey;
          this.formModel.verification_code = res.verificationCode;
          this.captchaVerified = true;
          this.captchaVisible = false;
        } catch (e) {
          await this.fetchClickCaptcha();
        } finally {
          this.captchaVerifying = false;
        }
      }
    }
  };
</script>

<style scoped>
  .captcha-trigger {
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr) 16px;
    gap: 10px;
    align-items: center;
    width: 100%;
    min-height: 58px;
    padding: 9px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    color: #3E4144;
    text-align: left;
    background: #FFFFFF;
    cursor: pointer;
  }
  .captcha-trigger:hover {
    border-color: #832C75;
  }
  .captcha-trigger-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 5px;
    color: #FFFFFF;
    font-size: 13px;
    background: #832C75;
  }
  .captcha-trigger-text strong,
  .captcha-trigger-text em {
    display: block;
    font-style: normal;
  }
  .captcha-trigger-text strong {
    font-size: 14px;
    line-height: 20px;
  }
  .captcha-trigger-text em {
    margin-top: 2px;
    color: #7E8589;
    font-size: 12px;
    line-height: 18px;
  }
  .captcha-trigger-arrow {
    color: #999999;
    font-size: 22px;
  }
  .captcha-modal {
    padding: 4px 0 2px;
  }
  .captcha-target {
    display: flex;
    gap: 14px;
    align-items: center;
    justify-content: space-between;
    min-height: 72px;
    padding: 8px 10px 8px 14px;
    border-radius: 5px;
    background: #F7EEF3;
  }
  .captcha-target span,
  .selected-line span {
    color: #7E6578;
    font-size: 12px;
  }
  .captcha-target img {
    width: 210px;
    max-width: 62%;
    height: 58px;
    object-fit: contain;
    user-select: none;
  }
  .captcha-image-stage {
    position: relative;
    width: 100%;
    height: 210px;
    margin-top: 16px;
    overflow: hidden;
    border: 1px solid #DFCBD8;
    border-radius: 5px;
    background: #F4F3F5;
    cursor: crosshair;
    user-select: none;
  }
  .captcha-image-stage img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .captcha-point {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 2px solid #FFFFFF;
    border-radius: 50%;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: bold;
    background: #832C75;
    box-shadow: 0 2px 8px rgba(47, 33, 51, 0.35);
    pointer-events: none;
    transform: translate(-50%, -50%);
  }
  .selected-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    margin-top: 14px;
    padding: 0 14px;
    border-radius: 5px;
    background: #FBF7FA;
  }
  .selected-line strong {
    color: #3E4144;
    font-size: 16px;
  }
  .login-box .more {
    font-size: 12px;
    font-weight: 500;
    color: #7E8589;
    line-height: 40px;
  }
  .login-box .more {
    margin-top: 10px;
    display: flex;
    cursor: pointer;
    align-items: center;
  }
  .login-box .more span {
    flex: 1;
  }
  .login-box .more span:first-child {
    display: flex;
    justify-content: flex-end;
    padding-right: 5px;
  }
  .login-box .more i {
    height: 10px;
    border-right: 1px solid #999999;
    width: 10px;
  }
  .login-box .more span:last-child {
    display: flex;
    align-items:flex-start ;
    padding-left: 10px;
  }
  .login-form {
    margin-top: 20px;
  }

  .login-box .name {
    font-size: 26px;
    font-weight: bold;
    color: #3E4144;
    line-height: 40px;
  }
  .login-box .small-name {
    font-size: 14px;
    font-weight: 400;
    color: #4A4E51;
    line-height: 40px;
  }
  .login-box .btn {
    background: #832C75;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 45px;
    text-align: center;
    cursor: pointer;
  }

  .name-box {
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    flex: 1;
    padding-left: 30px;
  }
  .login-container {
    width: 400px;
    margin-right: 200px;
  }
  .login-box {
    background: #FFFFFF;
    box-shadow: 0px 23px 25px 0px rgba(0, 0, 0, 0.25);
    border-radius: 12px;
    padding: 45px;
  }
</style>
